import { render } from "./OtpModel.vue?vue&type=template&id=78630cc2&scoped=true"
import script from "./OtpModel.vue?vue&type=script&lang=js"
export * from "./OtpModel.vue?vue&type=script&lang=js"

import "./OtpModel.vue?vue&type=style&index=0&id=78630cc2&scoped=true&lang=css"

import exportComponent from "/var/www/html/smartbooking/smartbooking-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78630cc2"]])

export default __exports__